import { useState, useContext } from "react";
// MSAL imports
// Context
import { AlertNotificationContext } from "../../contexts/AlertNotificationContext";
// Hooks
import { useBranchList } from "../../state/branchListState";
import { useCheckAPI } from "../../hooks/useCheckAPI";
// Components
import { ReportsHome } from "./ReportsHome";
import { ReportsForm } from "./ReportsForm";

import { reportsList } from "../../utils/reports";

// MUI
import Box from "@mui/material/Box";

export const Reports = ({ type }) => {
  // MSAL auth request
  const { setAlertNotification } = useContext(AlertNotificationContext);

  const [branches, setBranches] = useState([]);
  const { data, isSuccess } = useBranchList();

  // Success Function
  const successFunc = () => {
    const branchesArray = data.data.data.data.list.branch;
    branchesArray.unshift({ no: "", name: "All" });
    setBranches(branchesArray);
  };

  // Error Function
  const errorFunc = () =>
    setAlertNotification({
      message: `Error: ${data.data.status}: ${data.data.statusText}`,
      severity: "error",
    });

  // Hook to check the BC API for errors
  useCheckAPI(isSuccess, data, data?.data?.status, successFunc, errorFunc);

  const ReportsPage = ({ type }) => {
    if (type === "general") {
      return (
        <ReportsForm
          type={type}
          branches={branches}
          reports={reportsList[type]}
        />
      );
    } else if (type === "financial") {
      return (
        <ReportsForm
          type={type}
          branches={branches}
          reports={reportsList[type]}
        />
      );
    } else {
      return <ReportsHome />;
    }
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <ReportsPage type={type} />
      </Box>
    </>
  );
};
